export const uploadingContainerClassName = 'exeditor-file-uploading';
//# sourceMappingURL=constants.js.map